const attachmentsSection = $('#attachments-section');
const attachmentsCardsParents = attachmentsSection.find('.attachment-card-parent');

const addAttachmentsCardOpenAnimation = () => {
  attachmentsCardsParents.each(function () {
    const cardInner = $(this).find('.attachment-card-inner-parent');
    const cardOpenBtn = $(this).find('.attachment-card-open');
    const cardImage = $(this).find('.attachment-card-image');
    let isOpened = false;

    if (isDesktop()) {
      $(this).on('mouseenter', () => {
        animatePlusIcon(cardOpenBtn, false, 0.63, 270, 180);
        gsap.to(cardImage, {
          filter: 'blur(20px)',
          duration: 0.43,
          ease: 'linear',
          overwrite: 'auto',
        });
        gsap.to(cardInner, {
          y: 0,
          opacity: 1,
          duration: 0.63,
          ease: 'pageInEasing',
          overwrite: 'auto',
        });
      });

      $(this).on('mouseleave', () => {
        animatePlusIcon(cardOpenBtn, true, 0.63, 270, 180);
        gsap.to(cardImage, {
          filter: 'blur(0px)',
          duration: 0.43,
          ease: 'linear',
          overwrite: 'auto',
        });
        gsap.to(cardInner, {
          y: '12%',
          opacity: 0,
          duration: 0.63,
          ease: 'pageInEasing',
          overwrite: 'auto',
        });
      });
    } else {
      $(this).on('click', () => {
        animatePlusIcon(cardOpenBtn, isOpened, 0.63, 270, 180);
        gsap.to(cardImage, {
          filter: !isOpened ? 'blur(20px)' : 'blur(0px)',
          duration: 0.43,
          ease: 'linear',
          overwrite: 'auto',
        });
        gsap.to(cardInner, {
          y: !isOpened ? 0 : '12%',
          opacity: !isOpened ? 1 : 0,
          duration: 0.63,
          ease: 'pageInEasing',
          overwrite: 'auto',
        });
        isOpened = !isOpened;
      });
    }
  });
};

const addAttachmentsAnimation = () => {
  const gradientConfig = {
    gradient: 'linear-gradient(127deg, #081B48 0%, #8AD1DA 50%, #081B48 100%);',
    start: 120,
    end: 0,
  };

  const attachmentsTL = gsap.timeline({
    paused: true,
    onComplete: () => {
      addAttachmentsCardOpenAnimation();
    },
  });

  attachmentsTL.add(
    animateSectionTopperIn({
      sectionParent: attachmentsSection,
      gradientConfig: gradientConfig,
    }).play(),
    0
  );


  attachmentsTL.add(elementInAnimationYWOpacity(attachmentsCardsParents, '36%', 0, 1, 1, 0.84, 0, 0.1, 'start', 'inEasing', 'opacityInEasing').play(), 0.16);

  /*
  attachmentsCardsParents.each(function (index) {
    //attachmentsTL.add(addElementIn($(this), `36%`, 1, 'inEasing').play(), 0.16 + 0.1 * index);
  });
  */

  return attachmentsTL;
};

const initAttachments = () => {
  const attachmentsTL = addAttachmentsAnimation();
  ScrollTrigger.create({
    trigger: attachmentsSection,
    start: 'top top+=120%',
    end: 'top+=10% top',
    once: true,
    onEnter: () => {
      //attachmentsTL.play();
    },
    onUpdate: (self) => {
      attachmentsTL.progress(self.progress);
    },
  });
}

/*
$(window).on('load', () => {
  initAttachments();
});
*/

addSectionObserver(attachmentsSection, initAttachments, false, '50%');
